/**
 * Helper functions for celebration popup feature
 */

/**
 * Determines if a practice session is the first session of the day
 * Requirements: 1.1, 1.3
 * 
 * Logic: The backend's dailyStats.cardsStudied includes the current session.
 * If dailyStats.cardsStudied equals the session's cardsStudied, this is the first session.
 * 
 * @param {Object} sessionData - Session completion data
 * @param {number} sessionData.cardsStudied - Cards studied in this session
 * @param {Object} sessionData.dailyStats - Daily statistics from backend
 * @param {number} sessionData.dailyStats.totalCardsStudied - Total cards studied today (including this session)
 * @returns {boolean} True if this is the first session of the day
 */
export function isFirstSessionOfDay(sessionData) {
  // Handle missing or invalid data
  if (!sessionData || !sessionData.dailyStats) {
    return false;
  }

  const { cardsStudied, dailyStats } = sessionData;

  // Handle missing cardsStudied values
  if (cardsStudied === undefined || cardsStudied === null) {
    return false;
  }

  if (dailyStats.totalCardsStudied === undefined || dailyStats.totalCardsStudied === null) {
    return false;
  }

  // If daily total equals this session's count, it's the first session
  return dailyStats.totalCardsStudied === cardsStudied;
}

export function getPlayerLevel(summary) {
  const level = Number(summary?.level);
  if (Number.isInteger(level) && level >= 1) return level;

  const rawExp = summary?.exp ?? summary?.totalScoreGained;
  if (rawExp === null || rawExp === undefined || !Number.isFinite(Number(rawExp))) return null;
  const step = Number(summary?.levelExpStep) || 5000;
  if (step <= 0) return null;
  return Math.floor(Math.max(0, Number(rawExp)) / step) + 1;
}
